import {
    EnumGrupoProducto,
    EnumIntervaloProducto,
    EnumProductos,
    EnumTipoProducto,
    EnumVisibilidadProducto,
    ListProductos,
} from "../settings/enumConfig";
import { apiProductoCreateProducto, apiProductoGetObtenerProducto } from "../settings/apiConfig";
import { createContext, useContext, useState } from "react";
import {
    fnHandleChangeChek,
    fnHandleChangeText,
    fnHandleChangeUDecimal,
    fnHandleChangeUInteger,
} from "../settings/handleConfig";
import { fnPrevent, fnPreventBlur } from "../settings/preventConfig";
import { getFormProducto, getModelProducto } from "../models/ProductoModel";

import { useLayout } from "./LayoutContext";
import { useLogin } from "./LoginContext";
import { useRequest } from "./RequestContext";

export const ProductoContext = createContext();

export function ProductoProvider(props) {
    const { handleOpenAlert } = useLayout();
    const { usuarioSesion } = useLogin();
    const { Get, Post } = useRequest();

    const [listaProductos, setListaProductos] = useState([]);
    const [productoSeleccionado, setProductoSeleccionado] = useState(getModelProducto());
    const [modalOpenFormProducto, setModalOpenFormProducto] = useState(false);
    const [modalOpenDetalleProducto, setModalOpenDetalleProducto] = useState(false);
    const [modalOpenEliminarProducto, setModalOpenEliminarProducto] = useState(false);
    const [formProducto, setFormProducto] = useState(getFormProducto());

    const handleOpenFormProducto = (value) => {
        setModalOpenFormProducto(value);
    };

    const handleOpenDetalleProducto = (value) => {
        setModalOpenDetalleProducto(value);
    };

    const handleOpenEliminarProducto = (value) => {
        setModalOpenEliminarProducto(value);
    };

    const handleChangeProductoSeleccionado = (value) => {
        setProductoSeleccionado(value);
    };

    const handleChangeFormProductoText = fnHandleChangeText(formProducto, setFormProducto);

    const handleChangeFormProductoGrupoProductos = (e) => {
        const { rdTipoProducto, slcGrupoProducto, chkPremium } = getFormProducto();
        const value = e.target.value;
        if (formProducto.rdTipoProducto.value == EnumTipoProducto.Plan) {
            setFormProducto({
                ...formProducto,
                slcGrupoProducto: {
                    ...slcGrupoProducto,
                    value: value,
                    error: value === "",
                },
                rdTipoProducto: {
                    ...rdTipoProducto,
                    value: EnumTipoProducto.Membresia,
                },
                chkPremium: {
                    ...chkPremium,
                    value: false,
                },
            });
        } else {
            setFormProducto({
                ...formProducto,
                slcGrupoProducto: {
                    ...slcGrupoProducto,
                    value: value,
                    error: value === "",
                },
                chkPremium: {
                    ...chkPremium,
                    value: false,
                },
            });
        }
    };

    const handleChangeFormProductoCheckComercial = (e) => {
        const { rdTipoProducto, chkComercial, chkPremium } = getFormProducto();
        const value = e.target.checked;
        if (formProducto.rdTipoProducto.value == EnumTipoProducto.Plan) {
            setFormProducto({
                ...formProducto,
                chkComercial: {
                    ...chkComercial,
                    value: value,
                    error: value === "",
                },
                rdTipoProducto: {
                    ...rdTipoProducto,
                    value: EnumTipoProducto.Membresia,
                },
                chkPremium: {
                    ...chkPremium,
                    value: false,
                    disabled: false,
                },
            });
        } else {
            setFormProducto({
                ...formProducto,
                chkComercial: {
                    ...chkComercial,
                    value: value,
                    error: value === "",
                },
                chkPremium: {
                    ...chkPremium,
                    value: false,
                    disabled: false,
                },
            });
        }
    };

    const handleChangeFormProductoCheckPremium = (e) => {
        const { txtCantidadOrientacion, txtCantidadAsistenciaPsicologica, chkPremium } = getFormProducto();
        const value = e.target.checked;
        if (value == true) {
            setFormProducto({
                ...formProducto,
                chkPremium: {
                    ...chkPremium,
                    value: value,
                },
                txtCantidadOrientacion: {
                    ...txtCantidadOrientacion,
                    value: "",
                },
                txtCantidadAsistenciaPsicologica: {
                    ...txtCantidadAsistenciaPsicologica,
                    value: "",
                },
            });
        } else {
            setFormProducto({
                ...formProducto,
                chkPremium: {
                    ...chkPremium,
                    value: value,
                },
            });
        }
    };

    const handleChangeFormProductoTipoProducto = (e) => {
        const {
            rdTipoProducto,
            slcVisible,
            slcIntervalo,
            txtMesesVigencia,
            txtCantidadAsistenciaPsicologica,
            txtCantidadEspecialistaPsicologo,
            txtCantidadOrientacion,
            chkPremium,
        } = getFormProducto();

        const value = e.target.value;
        if (value == EnumTipoProducto.Plan) {
            setFormProducto({
                ...formProducto,
                rdTipoProducto: {
                    ...rdTipoProducto,
                    value: value,
                    error: value === "",
                },
                txtCantidadAsistenciaPsicologica: {
                    ...txtCantidadAsistenciaPsicologica,
                    value: "",
                },
                txtCantidadEspecialistaPsicologo: {
                    ...txtCantidadEspecialistaPsicologo,
                    value: "",
                },
                txtCantidadOrientacion: {
                    ...txtCantidadOrientacion,
                    value: "",
                },
                chkPremium: {
                    ...chkPremium,
                    value: true,
                    disabled: true,
                },
                slcVisible: {
                    ...slcVisible,
                    value: 0,
                },
            });
        } else if (value == EnumTipoProducto.Membresia) {
            setFormProducto({
                ...formProducto,
                rdTipoProducto: {
                    ...rdTipoProducto,
                    value: value,
                    error: value === "",
                },
                slcIntervalo: {
                    ...slcIntervalo,
                    value: "",
                },
                chkPremium: {
                    ...chkPremium,
                    disabled: false,
                },
                slcVisible: {
                    ...slcVisible,
                    value: 0,
                },
            });
        } else if (value == EnumTipoProducto.Servicio) {
            setFormProducto({
                ...formProducto,
                rdTipoProducto: {
                    ...rdTipoProducto,
                    value: value,
                    error: value === "",
                },
                slcIntervalo: {
                    ...slcIntervalo,
                    value: "",
                },
                txtMesesVigencia: {
                    ...txtMesesVigencia,
                    value: "",
                },
                chkPremium: {
                    ...chkPremium,
                    disabled: false,
                },
                slcVisible: {
                    ...slcVisible,
                    value: 0,
                },
            });
        }
    };

    const handleChangeFormProductoUDec = fnHandleChangeUDecimal(formProducto, setFormProducto);
    const handleChangeFormProductoUInt = fnHandleChangeUInteger(formProducto, setFormProducto);
    const handleChangeFormProductoCheck = fnHandleChangeChek(formProducto, setFormProducto);

    const handleClickNuevoProducto = () => {
        const producto = getModelProducto();
        setProductoSeleccionado(producto);
        fnFillFormProducto(producto);
        setModalOpenFormProducto(true);
    };

    const handleClickEditarProducto = () => {
        if (productoSeleccionado.iIdProducto === 0) {
            handleOpenAlert("Seleccione un producto para editar...");
            return;
        }
        if (productoSeleccionado.iIdProducto === EnumProductos.OrientacionEspecialistaID) {
            handleOpenAlert(
                "Este producto no se puede editar debito a que solo está habilitado para orientaciones de médicos especialistas",
                "info"
            );
            return;
        }
        fnFillFormProducto(productoSeleccionado);
        setModalOpenFormProducto(true);
    };

    const handleClickDetalleProducto = () => {
        if (productoSeleccionado.iIdProducto === 0) {
            handleOpenAlert("Seleccione un producto para ver el detalle...");
            return;
        }
        setModalOpenDetalleProducto(true);
    };

    const handleClickEliminarProducto = () => {
        if (productoSeleccionado.iIdProducto === 0) {
            handleOpenAlert("Seleccione un producto para eliminar...");
            return;
        }
        if (ListProductos.includes(productoSeleccionado.iIdProducto)) {
            handleOpenAlert("El producto seleccionado no puede eliminarse", "warning");
            return;
        }
        setModalOpenEliminarProducto(true);
    };

    const handleClickRefrescarDatos = () => {
        fnObtenerProductos();
    };

    const handleSubmitFormProducto = (e) => {
        fnPrevent(e);
        const {
            rdTipoProducto,
            chkComercial,
            chkPremium,
            txtIdPlan,
            txtNombreProducto,
            txtNombreCorto,
            txtDescripcion,
            slcGrupoProducto,
            txtCosto,
            txtMesesVigencia,
            slcIcono,
            txtPrefijoFolio,
            txtCantidadOrientacion,
            txtCantidadAsistenciaPsicologica,
            txtCantidadEspecialistaPsicologo,
            slcVisible,
            slcIntervalo,
        } = formProducto;

        const grupo = parseInt(slcGrupoProducto.value);
        const costo = parseFloat(txtCosto.value);
        const mes = parseInt(txtMesesVigencia.value);

        const numori = parseInt(txtCantidadOrientacion.value);
        const numasis = parseInt(txtCantidadAsistenciaPsicologica.value);
        const numespe = parseInt(txtCantidadEspecialistaPsicologo.value);

        var errorVigencia = false;
        var errorVigenciaPlan = false;
        if ((rdTipoProducto.value == EnumTipoProducto.Membresia || rdTipoProducto.value == EnumTipoProducto.Plan) && (isNaN(mes) || mes <= 0)) {
            errorVigencia = true;
        }
        // console.log("tipo "+rdTipoProducto.value);
        if (rdTipoProducto.value == EnumTipoProducto.Plan) {
            // console.log("valida");
            if ((isNaN(mes) || mes <= 0 || mes > 52) && slcIntervalo.value == "week") {
                errorVigencia = true;
                errorVigenciaPlan = true;
            }
            else if ((isNaN(mes) || mes <= 0 || mes > 12) && slcIntervalo.value == "month") {
                errorVigencia = true;
                errorVigenciaPlan = true;
            }
            else if ((isNaN(mes) || mes <= 0 || mes > 1) && slcIntervalo.value == "year") {
                errorVigencia = true;
                errorVigenciaPlan = true;
            }
        }
        // console.log("intervalo "+slcIntervalo.value);
        // console.log("mes "+mes);
        // console.log("error "+errorVigencia);
        // console.log("error plan "+errorVigenciaPlan);

        const form = {
            ...formProducto,
            txtNombreProducto: {
                ...txtNombreProducto,
                error: txtNombreProducto.value === "",
            },
            txtNombreCorto: { ...txtNombreCorto, error: txtNombreCorto.value === "" },
            txtDescripcion: { ...txtDescripcion, error: txtDescripcion.value === "" },
            slcGrupoProducto: {
                ...slcGrupoProducto,
                error: isNaN(grupo) || grupo <= 0,
            },
            slcVisible: {
                ...slcVisible,
                error:
                    (rdTipoProducto.value == EnumTipoProducto.Membresia ||
                        rdTipoProducto.value == EnumTipoProducto.Plan) &&
                    slcVisible.value === "",
            },
            slcIntervalo: {
                ...slcIntervalo,
                error:
                    (rdTipoProducto.value == EnumTipoProducto.Membresia ||
                        rdTipoProducto.value == EnumTipoProducto.Plan) &&
                    slcIntervalo.value === "",
            },
            txtCosto: { ...txtCosto, error: isNaN(costo) || costo < 4 },
            txtMesesVigencia: {
                ...txtMesesVigencia,
                error: errorVigencia,
                errorplan: errorVigenciaPlan,
            },
            txtCantidadOrientacion: {
                ...txtCantidadOrientacion,
                error: false,
            },
            txtCantidadAsistenciaPsicologica: {
                ...txtCantidadAsistenciaPsicologica,
                error: false,
            },
            txtCantidadEspecialistaPsicologo: {
                ...txtCantidadEspecialistaPsicologo,
                error: false,
            },
            slcIcono: { ...slcIcono, error: slcIcono.value === "" },
            txtPrefijoFolio: {
                ...txtPrefijoFolio,
                error: txtPrefijoFolio.value === "",
            },
        };
        setFormProducto(form);
        if (
            Object.values(form)
                .map((x) => x.error)
                .includes(true)
        ) {
            return;
        }

        const entProducto = {
            iIdProducto: productoSeleccionado.iIdProducto,
            iIdTipoProducto: parseInt(rdTipoProducto.value),
            sNombre: txtNombreProducto.value,
            sNombreCorto: txtNombreCorto.value,
            sDescripcion: txtDescripcion.value,
            iIdGrupoProducto: parseInt(slcGrupoProducto.value),
            fCosto: parseFloat(txtCosto.value),
            iFrecuencia:
                rdTipoProducto.value === EnumTipoProducto.Servicio.toString() ? 1 : parseInt(txtMesesVigencia.value),
            iOrientacion: (chkPremium.value && rdTipoProducto.value === EnumTipoProducto.Plan.toString()) ? 0 : txtCantidadOrientacion.value,
            iAsistenciaPsicologica: (chkPremium.value && rdTipoProducto.value === EnumTipoProducto.Plan.toString()) ? 0 : txtCantidadAsistenciaPsicologica.value,
            iConsultaPsicologica:
                rdTipoProducto.value === EnumTipoProducto.Plan.toString()
                    ? null
                    : txtCantidadEspecialistaPsicologo.value,
            sIntervalo: rdTipoProducto.value === EnumTipoProducto.Servicio.toString() ? "day" : slcIntervalo.value,
            iVisiblePremium:
                EnumGrupoProducto.LocutoriosProducts !== slcGrupoProducto.value || chkComercial.value
                    ? slcVisible.value
                    : null,
            bComercial: chkComercial.value,
            sIcon: slcIcono.value,
            bPremium: chkPremium.value,
            sPrefijoFolio: txtPrefijoFolio.value,
            iIdUsuarioMod: usuarioSesion.iIdUsuario,
            sIdPlan: txtIdPlan.value !== "" ? txtIdPlan.value : null,
            bActivo: true,
            bBaja: false,
        };
        fnGuardarProducto(entProducto);
    };

    const handleSubmitEliminarProducto = () => {
        const entProducto = {
            iIdProducto: productoSeleccionado.iIdProducto,
            iIdUsuarioMod: usuarioSesion.iIdUsuario,
            bActivo: false,
            bBaja: true,
        };
        fnEliminarProducto(entProducto);
    };

    const fnFillFormProducto = (producto) => {
        const {
            rdTipoProducto,
            chkComercial,
            txtNombreProducto,
            txtNombreCorto,
            txtDescripcion,
            slcGrupoProducto,
            txtCosto,
            txtMesesVigencia,
            slcIcono,
            chkPremium,
            txtIdPlan,
            txtPrefijoFolio,
            slcVisible,
            slcIntervalo,
            txtCantidadOrientacion,
            txtCantidadAsistenciaPsicologica,
            txtCantidadEspecialistaPsicologo,
        } = getFormProducto();

        var isdisabled = false,
            isdisablecheck;
        if (producto.iIdProducto !== 0) {
            /* Se bloquearan los campos para que no se modifiquen los planes */
            isdisabled = true;
            isdisablecheck = producto.iIdTipoProducto === EnumTipoProducto.Plan;
        }

        setFormProducto({
            ...formProducto,
            rdTipoProducto: {
                ...rdTipoProducto,
                value: !producto.iIdTipoProducto ? "" : producto.iIdTipoProducto,
                disabled: isdisabled,
            },
            chkPremium: {
                ...chkPremium,
                value: !producto.bPremium ? false : producto.bPremium,
                disabled: isdisabled,
            },
            chkComercial: {
                ...chkComercial,
                value: !producto.bComercial ? false : producto.bComercial,
                disabled: isdisabled,
            },
            txtNombreProducto: {
                ...txtNombreProducto,
                value: !producto.sNombre ? "" : producto.sNombre,
            },
            txtNombreCorto: {
                ...txtNombreCorto,
                value: !producto.sNombreCorto ? "" : producto.sNombreCorto,
            },
            txtDescripcion: {
                ...txtDescripcion,
                value: !producto.sDescripcion ? "" : producto.sDescripcion,
            },
            slcGrupoProducto: {
                ...slcGrupoProducto,
                value: !producto.iIdGrupoProducto ? "" : producto.iIdGrupoProducto,
                disabled: isdisabled,
            },
            slcVisible: {
                ...slcVisible,
                value: !producto.iVisiblePremium ? 0 : producto.iVisiblePremium,
            },
            slcIntervalo: {
                ...slcIntervalo,
                value: !producto.sIntervalo ? "" : producto.sIntervalo,
                disabled: isdisabled,
            },
            txtCantidadOrientacion: {
                ...txtCantidadOrientacion,
                value: producto.iOrientacion == null ? "" : producto.iOrientacion,
            },
            txtCantidadAsistenciaPsicologica: {
                ...txtCantidadAsistenciaPsicologica,
                value: producto.iAsistenciaPsicologica == null ? "" : producto.iAsistenciaPsicologica,
            },
            txtCantidadEspecialistaPsicologo: {
                ...txtCantidadEspecialistaPsicologo,
                value: producto.iConsultaPsicologica == null ? "" : producto.iConsultaPsicologica,
            },
            txtCosto: { ...txtCosto, value: !producto.fCosto ? "" : producto.fCosto },
            txtMesesVigencia: {
                ...txtMesesVigencia,
                value: !producto.iFrecuencia ? "" : producto.iFrecuencia,
                disabled: isdisabled,
            },
            slcIcono: { ...slcIcono, value: !producto.sIcon ? "" : producto.sIcon },
            txtPrefijoFolio: {
                ...txtPrefijoFolio,
                value: !producto.sPrefijoFolio ? "" : producto.sPrefijoFolio,
            },
            txtIdPlan: {
                ...txtIdPlan,
                value: !producto.sIdPlan ? "" : producto.sIdPlan,
            },
        });
    };

    const fnObtenerProductos = async (iIdProducto = null) => {
        const payload = {
            loader: "Consultando productos...",
            url: apiProductoGetObtenerProducto + "?iIdProducto=" + iIdProducto,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            setListaProductos(
                response.Result.map((producto) => ({
                    ...producto,
                    iMesVigencia: producto.iIdTipoProducto === EnumTipoProducto.Servicio ? "" : producto.iMesVigencia,
                }))
            );
        }
    };

    const fnGuardarProducto = async (entProducto) => {
        const payload = {
            loader: "Guardando producto...",
            url: apiProductoCreateProducto,
            body: entProducto,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setModalOpenFormProducto(false);
            setProductoSeleccionado(entProducto);
            await fnObtenerProductos();
        }
        fnPreventBlur();
    };

    const fnEliminarProducto = async (entProducto) => {
        const payload = {
            loader: "Eliminando producto...",
            url: apiProductoCreateProducto,
            body: entProducto,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setModalOpenEliminarProducto(false);
            setProductoSeleccionado(getModelProducto());
            await fnObtenerProductos();
        }
    };

    return (
        <ProductoContext.Provider
            value={{
                listaProductos,
                productoSeleccionado,
                modalOpenFormProducto,
                modalOpenDetalleProducto,
                modalOpenEliminarProducto,
                formProducto,
                handleOpenFormProducto,
                handleOpenDetalleProducto,
                handleOpenEliminarProducto,
                handleChangeProductoSeleccionado,
                handleChangeFormProductoText,
                handleChangeFormProductoUDec,
                handleChangeFormProductoUInt,
                handleChangeFormProductoCheck,
                handleChangeFormProductoGrupoProductos,
                handleChangeFormProductoCheckComercial,
                handleChangeFormProductoTipoProducto,
                handleChangeFormProductoCheckPremium,
                handleClickNuevoProducto,
                handleClickEditarProducto,
                handleClickDetalleProducto,
                handleClickEliminarProducto,
                handleClickRefrescarDatos,
                handleSubmitFormProducto,
                handleSubmitEliminarProducto,
            }}
        >
            {props.children}
        </ProductoContext.Provider>
    );
}

export function useProducto() {
    return useContext(ProductoContext);
}
